import styles from "./styles.module.scss";
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import AvTimerIcon from '@mui/icons-material/AvTimer';
import { formatCurrency } from "../../../../utils/formatCurrency";

interface CardInfoProps {
  text: string,
  value: number,
  type: string,
  icon: string
}

export const CardInfo: React.FC<CardInfoProps> = ({
  text, value, type, icon
}) => {

  function selectedIcon () {
    switch (icon) {
      case "CurrencyExchangeIcon":
        return <CurrencyExchangeIcon width="8" height="8" />
        break;
      case "AttachMoneyIcon":
        return <AttachMoneyIcon width="8" height="8" />
        break;
      case "AccessTimeIcon":
        return <AccessTimeIcon width="8" height="8" />
        break;
      case "MoneyOffIcon":
        return <MoneyOffIcon width="8" height="8" />
        break;
      case "ShowChartIcon":
        return <ShowChartIcon width="8" height="8" />
        break;
      case "AvTimerIcon":
        return <AvTimerIcon width="8" height="8" />
        break;
      default:
        break;
    }

  }
  
  return (
    <div className={styles.card}>
      <h3 className={styles.valor}>{type == "hour" ? value + " h" : formatCurrency(value)}</h3>
      <div className={styles.divContainer}>
        {selectedIcon()}
        <label className={styles.label}>{text}</label>
      </div>
    </div>
  );
};
